<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学生" name="0">
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

          <!--列表-->
          <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
          <div class="tbl-scroll-host">
          <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
            ref="table" style="width: 100%" class="custom-tbl">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="Id" label="订单号" width></el-table-column>
            <el-table-column prop="CardNo" label="卡号" width></el-table-column>
            <el-table-column prop="UserName" label="姓名" width></el-table-column>
            <el-table-column prop="TotalMoney" label="总金额" width></el-table-column>
            <el-table-column prop="DiscountMoney" label="优惠金额" width></el-table-column>
            <el-table-column prop="PayMoney" label="总支付金额" width></el-table-column>
            <el-table-column prop="PayType" label="支付类型" width="" :formatter="formatPayType">
            </el-table-column>

            <el-table-column prop="Transactions" label="消费模式" width="" :formatter="formatTransactions">
            </el-table-column>

            <el-table-column prop="PayTime" label="交易时间" width></el-table-column>

            <el-table-column prop="Status" label="状态" width>
              <template slot-scope="scope">
                <el-tag :type="scope.row.Status == '1' ? 'success' : 'danger'" disable-transitions>{{ scope.row.Status
                  ==
                  '1' ?
                  "已支付" :
                  "已撤销" }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="DepartmentName" label="部门" width></el-table-column>

            <el-table-column prop="DeviceSerialNo" label="序列号" width></el-table-column>
            <el-table-column prop="InstallAddress" label="安装位置" width></el-table-column>
            <el-table-column prop="SourceType" label="来源类型">
              <template slot-scope="scope">
                <span v-if="scope.row.SourceType === '水电控'" style="color: var(--btn-primary, #2563eb); cursor: pointer;"
                  @click="showWaterElectricDetail(scope.row)">
                  {{ scope.row.SourceType }}
                </span>
                <span v-else>
                  {{ scope.row.SourceType }}
                </span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Status == '1' && scope.row.SourceType != '水电控'"
                  @click="handleRevocation(scope.row)" type="text">退还</el-button>
              </template>
            </el-table-column>

          </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="教师" name="1">
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
          <!--列表-->
          <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
          <div class="tbl-scroll-host">
          <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
            ref="table" style="width: 100%" class="custom-tbl">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="Id" label="订单号" width></el-table-column>
            <el-table-column prop="CardNo" label="卡号" width></el-table-column>
            <el-table-column prop="UserName" label="姓名" width></el-table-column>
            <el-table-column prop="TotalMoney" label="总金额" width></el-table-column>
            <el-table-column prop="DiscountMoney" label="优惠金额" width></el-table-column>
            <el-table-column prop="PayMoney" label="总支付金额" width></el-table-column>
            <el-table-column prop="PayType" label="支付类型" width="" :formatter="formatPayType">
            </el-table-column>

            <el-table-column prop="Transactions" label="消费模式" width="" :formatter="formatTransactions">
            </el-table-column>

            <el-table-column prop="PayTime" label="交易时间" width></el-table-column>

            <el-table-column prop="Status" label="状态" width>
              <template slot-scope="scope">
                <el-tag :type="scope.row.Status == '1' ? 'success' : 'danger'" disable-transitions>{{ scope.row.Status
                  ==
                  '1' ?
                  "已支付" :
                  "已撤销" }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="DepartmentName" label="部门" width></el-table-column>

            <el-table-column prop="DeviceSerialNo" label="终端序列号" width></el-table-column>

            <el-table-column prop="SourceType" label="来源类型">
              <template slot-scope="scope">
                <span v-if="scope.row.SourceType === '水电控'" style="color: var(--btn-primary, #2563eb); cursor: pointer;"
                  @click="showWaterElectricDetail(scope.row)">
                  {{ scope.row.SourceType }}
                </span>
                <span v-else>
                  {{ scope.row.SourceType }}
                </span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Status == '1' && scope.row.Transactions != '4'"
                  @click="handleRevocation(scope.row)" type="text">退还</el-button>
              </template>
            </el-table-column>

          </el-table>
          </div>

        </el-tab-pane>
      </el-tabs>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

    <el-dialog title="水电控详情" :visible.sync="waterElectricDialogVisible" width="400px">
      <div v-if="currentWaterElectric" style="padding: 10px 0;">
        <el-descriptions column="1" border>
          <el-descriptions-item label="设备描述">{{ currentWaterElectric.DeviceDesc || '-' }}</el-descriptions-item>
          <el-descriptions-item label="工作模式">
            {{ currentWaterElectric.WorkingMode === 1 ? '计时' : (currentWaterElectric.WorkingMode === 2 ? '计量' : '-') }}
          </el-descriptions-item>
          <el-descriptions-item label="用量">{{ currentWaterElectric.Usage != null ? currentWaterElectric.Usage : '-'
            }}</el-descriptions-item>
          <el-descriptions-item label="时长">{{ currentWaterElectric.Duration != null ? currentWaterElectric.Duration :
            '-'
            }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getPowerControlRecords, revocation, exportPowerControlRecords } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      waterElectricDialogVisible: false,
      currentWaterElectric: null,
      activeName: "0",
      filters: {
      },
      searchList: [
        {
          label: '卡号',
          key: 'cardId',
        },
        {
          label: '姓名',
          key: 'name',
        },
        {
          label: '开始日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: ""
    };
  },
  computed: {
  },
  methods: {
    showWaterElectricDetail(row) {
      this.currentWaterElectric = row;
      this.waterElectricDialogVisible = true;
    },
    handleClick(tab, event) {
      this.page = 1;
      this.handleQuery();
    },

    formatTransactions: function (row, column) {
      var str = "";
      if (row.Transactions == '1') {
        str = "普通消费";
      } else if (row.Transactions == '2') {
        str = "时段消费"
      } else if (row.Transactions == '3') {
        str = "离线消费"
      } else if (row.Transactions == '4') {
        str = "限次消费"
      } else if (row.Transactions == '5') {
        str = "固定金额消费"
      }

      return str;
    },

    formatPayType: function (row, column) {

      var str = "";
      if (row.PayType == '1') {
        str = "刷卡";
      } else if (row.PayType == '2') {
        str = "人脸"
      }

      return str;
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName
      };
      this.listLoading = true;
      //NProgress.start();
      getPowerControlRecords(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },

    handleRevocation(row) {
      this.$confirm("确认退还该消费记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {

          var para = { "OrderNo": row.Id }
          revocation(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "退还成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });

        })
        .catch(() => { });

    },
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };

        var fileName = this.activeName == 0 ? "学生用户消费记录" : "教师用户消费记录";
        const response = await exportPowerControlRecords(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

</style>
